export default "__VITE_ASSET__D73$Toxn__"